module.exports = __webpack_public_path__ + "img/3.de41e694.png";